import {adminAxios} from '@/Plugins/Axios';

// ສິດເງິນດ່ວນ COD — COD advance eligibility report (read-only; the advance
// product itself is not built). Lives under /api/admin — adminAxios' own
// baseURL. The list returns the envelope at the top level: {available, as_of,
// window, observed_days, config, data: rows[], meta: paginator}.
export async function fetchCodAdvanceEligibilityList(params = {}) {
    const response = await adminAxios.get('report/cod-advance-eligibility', {params});
    return response.data;
}

export async function fetchCodAdvanceEligibilitySummary() {
    const response = await adminAxios.get('report/cod-advance-eligibility/summary');
    return response.data;
}

export async function fetchCodAdvanceEligibilityDetail(customerId) {
    const response = await adminAxios.get('report/cod-advance-eligibility/' + customerId);
    return response.data;
}
